import { PaintColorItem } from './RenovationPaintingKitForm.types';

/** Selection of Tikkurila paint colors that can be ordered to paint walls in SATO apartments */
export const paintColors = {
  white: [
    {
      value: 'F497',
      label: 'Paperi',
      hexCode: '#f1f1ec',
    },
    {
      value: 'TIKV',
      label: 'Tikkurilan valkoinen',
      hexCode: '#eae7e1',
    },
    {
      value: 'G497',
      label: 'Höyry',
      hexCode: '#e8e7e1',
    },
    {
      value: 'F487',
      label: 'Höyhen',
      hexCode: '#e5e3dc',
    },
  ],
  neutral: [
    {
      value: 'G487',
      label: 'Batisti',
      hexCode: '#dbd7cf',
    },
    {
      value: 'V487',
      label: 'Valamo',
      hexCode: '#beb9b0',
    },
    {
      value: 'K487',
      label: 'Kalsiitti',
      hexCode: '#a4a097',
    },
  ],
  warm: [
    {
      value: 'G485',
      label: 'Kanvaasi',
      hexCode: '#e9e4db',
    },
    {
      value: 'TIKB',
      label: 'Tikkurilan Beige',
      hexCode: '#e3d7c8',
    },
    {
      value: 'J484',
      label: 'Linna',
      hexCode: '#cebfb0',
    },
    {
      value: 'K484',
      label: 'Granuliitti',
      hexCode: '#b6a593',
    },
  ],
  green: [
    {
      value: 'H495',
      label: 'Harso',
      hexCode: '#d1d3cd',
    },
    {
      value: 'X447',
      label: 'Merisavu',
      hexCode: '#cdd1c8',
    },
    {
      value: 'V447',
      label: 'Serpentiini',
      hexCode: '#aeb2a4',
    },
  ],
  blue: [
    {
      value: 'G490',
      label: 'Prinssi',
      hexCode: '#cfd9de',
    },
    {
      value: 'K498',
      label: 'Valkama',
      hexCode: '#bac1c6',
    },
  ],
  yellow: [
    {
      value: 'F306',
      label: 'Sorbetti',
      hexCode: '#f8ebd1',
    },
    {
      value: 'H456',
      label: 'Himmeli',
      hexCode: '#ead4ae',
    },
  ],
  red: [
    {
      value: 'F483',
      label: 'Illusio',
      hexCode: '#e5ddd8',
    },
    {
      value: 'X477',
      label: 'Keisarinna',
      hexCode: '#d2bfb8',
    },
  ],
} as const satisfies Record<string, PaintColorItem[]>;

const { white, ...restColors } = paintColors;

export const whitePaints = white;
export const colorPaints = Object.values(restColors).flat();
export const allPaints = [...whitePaints, ...colorPaints];
